var map = {
	"./ar-SA.json": [
		80756,
		756
	],
	"./be-BY.json": [
		3919,
		3919
	],
	"./bg-BG.json": [
		18971,
		8971
	],
	"./bn-BD.json": [
		44771,
		4771
	],
	"./ca-ES.json": [
		72769,
		2769
	],
	"./cs-CZ.json": [
		69174,
		9174
	],
	"./da-DK.json": [
		67277,
		7277
	],
	"./de-DE.json": [
		59699,
		9699
	],
	"./el-GR.json": [
		37879,
		7879
	],
	"./en-GB.json": [
		51885,
		1885
	],
	"./en-US.json": [
		19832,
		9832
	],
	"./es-ES.json": [
		48389,
		8389
	],
	"./fi-FI.json": [
		48555,
		8555
	],
	"./fr-FR.json": [
		37733,
		7733
	],
	"./he-IL.json": [
		60533,
		533
	],
	"./hi-IN.json": [
		93607,
		3607
	],
	"./hr-HR.json": [
		43637,
		3637
	],
	"./hu-HU.json": [
		67251,
		7251
	],
	"./id-ID.json": [
		24011,
		4011
	],
	"./it-IT.json": [
		38219,
		8219
	],
	"./ja-JP.json": [
		62200,
		2200
	],
	"./km-KH.json": [
		73714,
		3714
	],
	"./ko-KR.json": [
		29010,
		9010
	],
	"./me-ME.json": [
		31821,
		1821
	],
	"./mk-MK.json": [
		53861,
		3861
	],
	"./ml-IN.json": [
		53609,
		3609
	],
	"./nb-NO.json": [
		17982,
		7982
	],
	"./ne-NP.json": [
		74420,
		4420
	],
	"./nl-NL.json": [
		43593,
		3593
	],
	"./no-NO.json": [
		4387,
		4387
	],
	"./pl-PL.json": [
		95841,
		5841
	],
	"./pt-BR.json": [
		93085,
		3085
	],
	"./pt-PT.json": [
		78561,
		8561
	],
	"./pt-TL.json": [
		1605,
		1605
	],
	"./ro-RO.json": [
		95211,
		5211
	],
	"./ru-MD.json": [
		59727,
		9727
	],
	"./ru-RU.json": [
		68427,
		8427
	],
	"./sh-HR.json": [
		80518,
		518
	],
	"./si-LK.json": [
		21676,
		1676
	],
	"./sk-SK.json": [
		55673,
		5673
	],
	"./so-SO.json": [
		43726,
		1345
	],
	"./sq-AL.json": [
		6516,
		6516
	],
	"./sq-MK.json": [
		83425,
		3425
	],
	"./sr-CS.json": [
		41640,
		1640
	],
	"./sr-ME.json": [
		79616,
		9616
	],
	"./sr-RS.json": [
		92581,
		2581
	],
	"./sr-SP.json": [
		32565,
		2565
	],
	"./src/cboard.json": [
		56550,
		6550
	],
	"./sv-SE.json": [
		56330,
		6330
	],
	"./tg-TJ.json": [
		94388,
		4388
	],
	"./th-TH.json": [
		98345,
		8345
	],
	"./tk-TM.json": [
		62417,
		2417
	],
	"./tr-TR.json": [
		96869,
		6869
	],
	"./tu-TI.json": [
		87815,
		7815
	],
	"./uk-UA.json": [
		95267,
		5267
	],
	"./ur-PK.json": [
		40277,
		277
	],
	"./vi-VN.json": [
		98710,
		8710
	],
	"./zh-CN.json": [
		74138,
		4138
	],
	"./zu-ZA.json": [
		64679,
		4679
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 25079;
module.exports = webpackAsyncContext;